import type { PageConfig } from "../types";

export const page: PageConfig = {
  title: "Hub Health",
  description:
    "Find the facilities and hubs with the worst signal health, and see why each factor scored what it did.",
  icon: "signal",
  order: 30,
};
